import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-salary-forms-6-25',
    templateUrl: './salary-forms-6-25.component.html',
    styleUrl: './salary-forms-6-25.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SalaryForms625Component {

}
